<template>
	<div id="app">
				<!-- <title>{{ title }}</title> -->
        <!-- <link rel="icon" type="image/x-icon" href="https://firebasestorage.googleapis.com/v0/b/ellis-audio-webapp.appspot.com/o/general%2Ffavicon.ico?alt=media&token=1b0045ff-e664-48bf-bf0b-f661f3de75e0"> -->
				<!-- <meta name="Description" content="Ellis Audio provides high quality audio, visual and lighting equipment hire"> -->
				<!-- <link href="https://fonts.googleapis.com/css?family=Material+Icons" rel="preconnect"> -->
				<!-- <link href="https://fonts.googleapis.com/css?family=Material+Icons" rel="stylesheet"> -->
					<b-container fluid class="bg-white">

						<b-row>
					<!-- <div class="row"> -->
							<!-- <div class="col-8 col-sm-4 col-xl-2 mr-auto mx-sm-0 my-auto"> -->
								<b-col class="col-sm-6">
									<b-row>
									<!-- <b-container> -->
									<b-col class="col-5 col-sm-6 d-inline-block pr-0">
									<img src='https://firebasestorage.googleapis.com/v0/b/ellis-audio-webapp.appspot.com/o/general%2Flogo-200x200.jpg?alt=media&token=44fd22bc-7cf8-444d-8d61-f36c73c3c683' alt='ELLIS AUDIO' style="max-height:200px;object-fit:contain;max-width:100%">
								</b-col>
								<b-col class="col-7 col-sm-6 d-inline-block ">
									<div class="mt-4 mt-sm-5">
										<h1 class="text-center" style='font-size:200%;'>Ellis Audio</h1>
										<p class="text-center" style="color: darkgrey;">Parties | Weddings | Live <br>Music | Corporate Events</p>
									</div>
								</b-col>
							<!-- </b-container> -->
						</b-row>
							</b-col>
							<!-- </div> -->
							<!-- <div class="col-sm-5 col-md-4 col-xl-2 my-auto mx-auto"> -->
									
							<!-- </div> -->
							<!-- <div class="col-md-4 col-lg-3 d-none d-md-inline"> -->
								<b-col sm="0" md="3" class="d-none d-md-inline"></b-col>
								<b-col sm="0" md="3" class="d-none d-md-inline ml-auto">
									<!-- <div class="col-4 d-none d-md-block my-auto ml-auto"> -->
										<!-- <div class="row mt-2"> -->
												<div class="mt-5" style="">
													<a target="_blank" href="https://www.facebook.com/ellisAudioHire/">
															<img class="mx-auto d-block" style="height:50px;width:50px;margin:auto;" src="https://firebasestorage.googleapis.com/v0/b/ellis-audio-webapp.appspot.com/o/general%2Ffacebook.png?alt=media&token=512d627a-d65f-463d-b248-d93ecab0d8e2">
													</a>
												</div>
												<div class="mx-auto" style="">
									<div class="text-center">
												Get a Free Quote Today
												<br>
										<!-- </div> -->
										<!-- <div class="row mx-auto"> -->
												<a class="text-center" href="tel: ${ellisaudio.phone}"> {{ ellisaudio.phone }}</a>
												<br>
										<!-- </div> -->
										<!-- <div class="row mx-auto"> -->
												<a class="text-center" href="mailto: ${ellisaudio.email}"> {{ ellisaudio.email }}</a>
										</div>
										<!-- <div class="row mx-auto w-100 text-center">
												{{ ellisaudio.address }}
										</div> -->
								<!-- </div> -->
							<!-- </div> -->
					<!-- </div> -->
						</div>
					</b-col>
				</b-row>
			</b-container>
				<!-- Nav Menu -->
			<b-navbar class="navbar navbar-expand-sm bg-lt-blue navbar-dark sticky-top" style="width:100%;" toggleable="lg">
				<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
				<b-collapse class="mr-auto" id="nav-collapse" is-nav>
					<b-navbar-nav v-if="!isAdminPage">
							<b-nav-item to="/packages">Hire Packages</b-nav-item>
							<!-- <b-nav-item to="/products">Hire Equipment</b-nav-item> -->
							<b-nav-item-dropdown text="Hire Equipment">
								<b-nav-item to="/products/audio" style="color: rgba(255, 255, 255, 0.5);">Audio</b-nav-item>
								<b-nav-item to="/products/lighting" style="color: rgba(255, 255, 255, 0.5) !important;">Lighting</b-nav-item>
								<b-nav-item to="/products/power" style="color: rgba(255, 255, 255, 0.5) !important;">Power</b-nav-item>
								<b-nav-item to="/products/visual" style="color: rgba(255, 255, 255, 0.5) !important;">Visual</b-nav-item>
							</b-nav-item-dropdown>
							<b-nav-item to="/sales">Sales</b-nav-item>
							<b-nav-item to="/gallery">Gallery</b-nav-item>
							<b-nav-item to="/about">About Us</b-nav-item>
							<b-nav-item to="/ts&cs">Ts&Cs</b-nav-item>
					</b-navbar-nav>
					<b-navbar-nav v-if="isAdminPage">
							<b-nav-item to="/admin/packages">Hire Packages</b-nav-item>
							<b-nav-item to="/admin/products">Hire Equipment</b-nav-item>
							<b-nav-item to="/admin/sales">Sales</b-nav-item>
							<b-nav-item to="/admin/gallery">Gallery</b-nav-item>
					</b-navbar-nav>
				</b-collapse>
			</b-navbar>
			<div id="body">
				<div id='content' class="w-100">
					<router-view :isAdminPage="isAdminPage"></router-view>
				</div>
			</div>
			<div id='footer'>
				<a href="tel: ${ellisaudio.phone}">{{ ellisaudio.phone }}</a><br>
			<a href="mailto:${ellisaudio.email}">{{ ellisaudio.email }}</a><br>
			{{ ellisaudio.address }}<br>
			© Ellis Audio | ABN: {{ ellisaudio.abn }}<br>
			All hire is subject to <router-link to="/Ts&Cs">Ts & Cs</router-link><br>

			<!-- <div id="mob-popup">Get A Free Quote - <a href="tel: ${ellisaudio.phone}">{{ ellisaudio.phone }}</a></div> -->
		</div>
		</div>
</template>

<script>
export default {
	// name: 'app',
	data () {
		return {
			title: 'Ellis Audio - Brisbane',
			ellisaudio: {
				email: "hire@ellisaudio.com.au",
				phone: "0458 708 648",
				abn: "82 403 813 991",
				address: "Laura Street, Highgate Hill, QLD, 4101"
			},
			isAdminPage: false
		}
	},
		watch: {
		'$route' () {
			// react to route changes...
			this.name = this.$route.name
			// console.log(this.isAdminPage)
			// console.log("path")
			// console.log(this.$router.currentRoute.fullPath)
			this.isAdminPage = (this.$router.currentRoute.path.indexOf('/admin/')!=-1) ? true : false
		}
	},
		created: function(){
			// console.log(this.isAdminPage)
			// console.log(this)
			// console.log("path")
			// console.log(this.$router.currentRoute.path)
			this.isAdminPage = (this.$router.currentRoute.fullPath.indexOf('/admin/')!=-1) ? true : false
			// console.log(this.isAdminPage)

		}
}
</script>

<style>
	* {
		box-sizing: border-box;
		background-color:transparent;
	}
	
	html
	{
		width:100%;
		padding:0px;
		overflow:auto;
		margin:0;
		position: relative;
		background-color: black;
		background-size: cover;
		background-image: url("https://firebasestorage.googleapis.com/v0/b/ellis-audio-webapp.appspot.com/o/general%2Fthe-speaker-grill-412x660.jpg?alt=media&token=dbe0930a-599b-4662-836c-266880d3fbec"); 
		background-repeat: no-repeat;
		background-position: center;
		background-attachment: fixed;
		min-height:100%;
		font-family: 'Open Sans', sans-serif;
	}


	html button
	{
		cursor: pointer;
	}

	body
	{
		margin: 0px;
		background-color:transparent !important;
	}
	
/*	#header 
	{
		height:250px;
		z-index:10;
		position:absolute;
		width:100%;
		top:0;
	}*/

	#body 
	{
		padding-top:20px;
		margin: 0;
		overflow:auto;
		-webkit-overflow-scrolling: touch;
		padding-bottom: 130px;
		background-color:transparent;
	}

	#footer 
	{
		text-align:center;
		position:absolute;
		bottom:0;
		width:100%;
		height:130px;	 /* Height of the footer */
		background-color:black;
		color: white;
		padding-top:5px;
	}
	
	./*footer::after 
	{
	content: '';
	clear: both;
	display: table;
	}*/
	
	button:focus 
	{
		outline: none;
	}

	h1
	{
		font-family: 'Open Sans', sans-serif;
		text-align:center;
		font-size:medium;
	}

	h2
	{
		font-family: 'Open Sans', sans-serif;
		text-align:center;
		font-size:small;
	}

/*Header*/

/*	#logo
	{
		margin-left:5%;
		vertical-align: 50%;
		color:black;
	}

	#logo-text
	{
		margin: 0 0.5%;
		padding: 0 15px;
		max-height:10%;
		min-height:10%;
		width:220px;
		padding-top: 20px;
	}

	#logo:visited
	{color:inherit;
	}

	#tagline
	{
		margin-bottom: 0;
		/*display:none;*/
	/*}

	#getQuote
	{
		padding-top: 20px;
		margin-top:0;
		width:400px;
	}*/

	.bg-blue
	{
		background-color: #313deb;
	}
	.bg-lt-blue
	{
		background-color: #8587fe;
	}

	.bg-white
	{
		background-color:#fff;
	}

	.dropdown-menu
	{
		background-color:#8587fe !important;
	}

			.text-muted
		{
			font-size:14px;
		}
		/*#menu
		{
			display:inline-block;
		}
		#menu-btn
		{
			display:none;
		}*/

		.nav-link
		{
			color: rgba(255,255,255,.75);
		}

		.router-link-active
		{
			color: rgba(255,255,255,1);
		}

		@media (min-width: 0) {
		html
		{
			background-image: url("https://firebasestorage.googleapis.com/v0/b/ellis-audio-webapp.appspot.com/o/general%2Fthe-speaker-grill-412x660.jpg?alt=media&token=dbe0930a-599b-4662-836c-266880d3fbec"); 
		}
		.card-deck .card {
			flex: 0 0 calc(100% - 30px) !important;
		}
	/* #menu
		{
			display:none;
		}
		#menu-btn
		{
			display:flex;
		}*/
		.modal-backdrop
		{
			display: none;
		}
	}
	@media (min-width: 576px) {
		html
		{
			background-image: url("https://firebasestorage.googleapis.com/v0/b/ellis-audio-webapp.appspot.com/o/general%2Fthe-speaker-grill%20-%205000x2879.jpg?alt=media&token=57dc5e0e-1721-4f7b-b586-cff2c4bd2ef8"); 
		}
		.card-deck .card {
			flex: 0 0 calc(50% - 30px) !important;
		}
		/*#menu
		{
			display:flex;
		}
		#menu-btn
		{
			display:none;
		}*/
		.modal-backdrop
		{
			display: block;
		}
	}
	@media (min-width: 768px) {
		.card-deck .card {
			flex: 0 0 calc(33.3333333333% - 30px) !important;
		}
	}
	@media (min-width: 992px) {
		.card-deck .card {
			flex: 0 0 calc(25% - 30px) !important;
		}
	}
	@media (min-width: 1600px) {
		html
		{
			background-image: url("https://firebasestorage.googleapis.com/v0/b/ellis-audio-webapp.appspot.com/o/general%2Fthe-speaker-grill%20-%205000x2879.jpg?alt=media&token=57dc5e0e-1721-4f7b-b586-cff2c4bd2ef8"); 
		}
		.card-deck .card {
			flex: 0 0 calc(20% - 30px) !important;
		}
	}
</style>
